export default __webpack_public_path__ + "f687e646fb354a5bd8403d642b6fcb75.woff2";